import { MissingParamError } from "../../../utils/erros/erros";
import { MongoSelectorUtils } from "../../../utils/mongoselector.utils";

/**
 * @class
 * Cuida das operações de uma coleção
 *
 */
export class CollectionAdapter {
    constructor(collection) {
        this.collection = collection;
    }

    _normalizeSelector(selector) {
        return MongoSelectorUtils.normalizeForLocalCollection(selector);
    }

    countCollection(selector) {
        const normalized = this._normalizeSelector(selector);
        return (
            this.collection.find(normalized, { fields: { _id: 1 } }).count() ||
            0
        );
    }

    /**
     * @private
     * Garante que para executar métodos da coleção exista uma coleção
     *
     */
    _before() {
        if (!this.collection) new MissingParamError("Collection");
    }

    /**
     * @public
     * Realaiza find nos dados locais
     * @param {Object} selector
     * @returns {Object} { list: {Array}, total: {Number} }
     */
    findCollection(selector = {}, options = {}, responseFormat = "object") {
        this._before();
        const normalized = this._normalizeSelector(selector);
        const list = this.collection.find(normalized, options).fetch();
        if (responseFormat == "array") return list;
        return {
            list,
            total: this.collection.find(normalized).count()
        };
    }

    findOneCollection(selector = {}, options = {}) {
        this._before();
        const normalized = this._normalizeSelector(selector);
        return this.collection.findOne(normalized, options) || null;
    }

    /**
     * @public
     * @param {Array} data
     * @returns {Boolean}
     */
    createMany(data = []) {
        this._before();
        const total = data.length;
        if (!total) return false;
        for (let i = 0; i < total; i++) {
            const document = data[i];
            if (document.updatedAt)
                document.updatedAt = new Date(document.updatedAt).getTime();
            if (document.createdAt)
                document.createdAt = new Date(document.createdAt).getTime();
            this.create(document);
        }
        return true;
    }

    /**
     * @public
     * Cria um dado na coleção
     * @param {Object} document
     * @returns {String} _id
     */
    create(document) {
        this._before();
        try {
            return this.collection.insert(document);
        } catch (error) {
            return false;
        }
    }

    /**
     * @public
     * Remove dados da coleção
     * @param {Object}
     */
    deleteMany(selector = {}) {
        this._before();
        const normalized = this._normalizeSelector(selector);
        this.collection
            .find(normalized, { fields: { _id: 1 } })
            .forEach((document) => this.delete(document._id));
        return true;
    }

    /**
     * @public
     * Remove um registro da coleção somente remove apartir de um _id
     * @param {String} selector
     * @param {Number}
     */
    delete(_id) {
        this._before();
        if (typeof _id != "string") return false;
        return this.collection.remove(_id);
    }

    /**
     * @public
     * Atualiza ou criar um dado
     * @param {Object} selector
     * @param {Object} modifier
     */
    modify(selector, modifier) {
        this._before();
        delete modifier.$$hashKey;
        const normalized = this._normalizeSelector(selector);
        let response = this.collection.upsert(normalized, modifier);
        if (response.numberAffected) return true;
        return false;
    }
}
